<template>
  <div class="bio-link-image">
    <v-img
      v-if="item.image && item.image.src && !isImageBroken(item.image.src)"
      :src="item.image.src"
      :aspect-ratio="item.aspectRatio ? item.aspectRatio : 1.6"
      class="bio-link-image-media"
      eager
      :transition="false"
      @error="markImageBroken(item.image.src)"
    />
    <div v-else class="bio-media-placeholder">
      <v-icon size="40" color="#9AA5B1">mdi-image-off-outline</v-icon>
    </div>
    <div class="bio-link-image-scrim" :style="{background: `linear-gradient(to top, ${sectionColor} 0%, transparent 100%)`}"/>
    <div class="bio-link-image-body" :style="{color: sectionTextColor}">
      <p v-if="item.title" class="bio-link-image-title bio-link-title-clamp">{{ item.title }}</p>
      <p v-if="item.description" class="bio-link-image-desc">{{ item.description }}</p>
      <p v-if="destinationLabel" class="bio-link-destination">{{ destinationLabel }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageLinkCard',
  props: {
    item: { type: Object, required: true },
    destinationLabel: { type: String, default: null },
    isImageBroken: { type: Function, required: true },
    markImageBroken: { type: Function, required: true },
    sectionColor: { type: String, default: '#101827' },
    sectionTextColor: { type: String, default: '#FFFFFF' },
  },
}
</script>

<style scoped>
/* Text sits on top of the image itself (not in a separate colored band
   below it), with a scrim behind it for legibility — the card relies on
   elevation (see .bio-content-link-card-elevated in
   BioContentLinkRenderer.vue) to stand out instead of a colored
   border/fill, per feedback. Text uses the bio's own sectionTextColor
   (inline, see template) and the scrim behind it uses sectionColor, so
   the pairing is the same one already used for buttons elsewhere on the
   page and stays legible against it, per feedback. */
.bio-link-image {
  position: relative;
  overflow: hidden;
}
.bio-link-image-media {
  width: 100%;
}
.bio-media-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 160px;
  background: #EEF1F5;
}
.bio-link-image-scrim {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 45%;
  /* background is inline (see template) - it's the bio's own sectionColor
     fading to transparent, not a fixed color, per feedback. */
  pointer-events: none;
}
.bio-link-image-body {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 1.75rem 1rem 0.85rem;
}
.bio-link-image-title {
  font-weight: 700;
  font-size: 0.95rem;
  margin: 0;
  text-shadow: 0 1px 3px rgba(0,0,0,0.4);
}
.bio-link-image-desc {
  font-size: 0.82rem;
  opacity: 0.92;
  margin: 0.15rem 0 0;
  text-shadow: 0 1px 3px rgba(0,0,0,0.4);
}
.bio-link-destination {
  opacity: 0.85;
  font-size: 0.75em;
  margin: 0.1rem 0 0;
  text-shadow: 0 1px 3px rgba(0,0,0,0.4);
}
.bio-link-title-clamp {
  overflow-wrap: break-word;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal !important;
}
</style>
